<script>
import Common from '../../../common/Common.vue'
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Services from '../../../common/Services.vue'
import { applySessionScope } from '../../../utils/scope'

export default {
    init: async payload => {
        await payload.initTable()

        const role = await Common.getSubtype(payload)
        payload.role = role

        payload.isSuperAdminMaster = await Common.isSuperAdminMaster(payload)
        payload.accounts = await Services.filterAccounts(payload)
        const account = await Common.getAccountId(payload)

        payload.filters.account = account
        if (account) {
            payload.clients = await Services.filterClients(payload)
        }

        if (!payload.isSuperAdminMaster) {
            payload.columns.splice(1, 1)
        }

        if (payload.role === 'AUDITOR') {
            payload.columns.splice(1, 1)
        }
    },
    methods: {
        changeAccount: async function () {
            const state = this

            if (state.filters.account === '') {
                state.filters.client = ''
            }

            state.filterFromFirstPage()

            const account = state.filters.account
            state.clients = await Services.getClientsByAccount(state, account)
        },
        filter: function () {
            if (!applySessionScope(this, this.filters)) return

            this.isLoading = true
            this.items = []
            this.enrichFiltersWithPagination()
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.filters,
                `${Endpoints.companies.filter}`,
                response => {
                    this.applyServerPage(response)

                    this.isLoading = false
                },
                () => {
                    this.isLoading = false
                },
            )
        },
        async selectItem(params) {
            if (this.role === 'AUDITOR') return

            const data = params && params?.row ? JSON.parse(JSON.stringify(params.row)) : { ...this.siteObj }
            if (!data.account) {
                data.account = await Common.getAccountId(this)
            } else {
                data.account = data.account._id
            }

            if (!data.client) {
                data.client = await Common.getClientId(this)
            } else {
                data.client = data.client._id
            }

            if (!data?.address?._id) {
                data.address = {}
            }

            delete data.vgt_id
            delete data.originalIndex

            this.data = data

            this.$bvModal.show('createSiteModal')
        },

        initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.site.column.name'),
                    field: 'name',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.site.column.account'),
                    field: 'account',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                    sortFn: Common.sortAccountFn,
                },
                {
                    label: this.$t('str.table.site.column.client'),
                    field: 'client',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                    sortFn: Common.sortClientFn,
                },

                {
                    label: this.$t('str.table.site.column.address'),
                    field: 'address',
                    type: 'address',
                    width: '20%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                    sortFn: Common.sortAddressFn,
                },
                {
                    label: this.$t('str.table.site.column.enable.free.patrol'),
                    field: 'enableFreePatrol',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.site.column.owner'),
                    field: 'owner',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.site.column.creat.at'),
                    field: 'createDate',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.site.column.status'),
                    field: 'status',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: false,
                    filterable: false,
                },
            ]
            this.paginationOptions = this.buildServerPaginationOptions(this)
        },
        formatDate: Common.formatDateAndTime,
    },
}
</script>
